import './loadingLogo.css';

export default function LoadingLogo() {
    return (
        <div className="loading-logo">
            <svg xmlns="http://www.w3.org/2000/svg" width="450" height="450" viewBox="0 0 450 450">
                <g id="Group_1051" data-name="Group 1051" transform="translate(-200 -200)">
                    <ellipse id="Ellipse_2" data-name="Ellipse 2" cx="142" cy="141.5" rx="142" ry="141.5" transform="translate(283 285)" fill="#88cdf6"/>
                    <path id="Path_2" data-name="Path 2" d="M86.716,205.072c16.406,0,23.73-13.769,23.73-25.78,0-16.406-8.789-26.366-23.73-26.366H69.432c-7.031,0-11.718-4.687-11.718-12.6s4.687-12.6,11.718-12.6H85.544c14.062,0,21.093-12.6,21.093-25.195,0-13.769-7.031-25.195-21.093-25.195H69.432c-7.031,0-11.718-4.687-11.718-12.6s4.687-12.6,11.718-12.6H86.716c16.406,0,23.73-13.769,23.73-25.78C110.446,9.961,101.657,0,86.716,0H29.882C7.91,0,0,14.941,0,35.448V169.624c0,20.507,7.91,35.448,29.882,35.448Z" transform="matrix(0.966, -0.259, 0.259, 0.966, 343.42, 340.567)" fill="#f8fdff"/>
                </g>
                <svg className="loading-logo-spin">
                    <g id="Group_1050" data-name="Group 1050" transform="translate(-200 -200)">
                        <ellipse id="Ellipse_3" data-name="Ellipse 3" cx="16.5" cy="16" rx="16.5" ry="16" transform="translate(354 247)" fill="#88cdf6"/>
                        <circle id="Ellipse_4" data-name="Ellipse 4" cx="16.5" cy="16.5" r="16.5" transform="translate(469 568)" fill="#88cdf6"/>
                    </g>
                </svg>

                <svg className="loading-logo-spin-fade">
                    <g id="Group_1050" data-name="Group 1050" transform="translate(-200 -200)">
                        <ellipse id="Ellipse_3" data-name="Ellipse 3" cx="16.5" cy="16" rx="16.5" ry="16" transform="translate(354 247)" fill="#88cdf6"/>
                        <circle id="Ellipse_4" data-name="Ellipse 4" cx="16.5" cy="16.5" r="16.5" transform="translate(469 568)" fill="#88cdf6"/>
                    </g>
                </svg>
                <rect id="Rectangle_10027" data-name="Rectangle 10027" width="450" height="450" fill="none"/>
            </svg>
        </div>
    )
}